
import {
  createApp,
  defineComponent,
  ref,
  reactive,
  onBeforeMount,
  onMounted,
  nextTick,
} from "vue";
import CustomAudio from "@/components/CustomAudio.vue";
import { unLock } from "@/utils/liner-lock";

export default defineComponent({
  name: "TrueOrFalseContent",
  components: { CustomAudio },
  props: {
    question: {
      type: Object,
    },
    disabled: {
      type: Boolean,
    },
    showQuestionNum: {
      type: Boolean,
      default: true,
    },
    showQuestionScore: {
      type: Boolean,
      default: true,
    },
  },
  emits: ["changePartsAnswer"],
  setup(props, ctx) {
    // 是否展示题号
    // 题目标准答案
    let correctOption: any = ref(
      parseInt(props.question?.correct_option?.is_correct)
    );
    const disabledAnswer = ref(props.disabled);
    console.log("标准答案", correctOption);
    console.log("标准答案1", disabledAnswer.value);
    // 传进来的题目
    let questionData: any = ref(props.question);
    // 选中的答案
    let currentAnswer: any = ref(undefined);

    // 转换数据
    const handleTitleHtml = () => {
      if (questionData.value.answer_params !== undefined) {
        currentAnswer.value = questionData.value.answer_params.is_correct;
      } else {
        currentAnswer.value = undefined;
      }

      let html = questionData.value.title;

      const audioExp = new RegExp("<kbd>.*?</kbd>", "g");
      const srcExp = new RegExp('src="([^"]+)');
      let match;
      let contentHtml = html;

      while ((match = audioExp.exec(html)) !== null) {
        contentHtml = contentHtml.replace(
          '<span style="color: rgb(159, 171, 183);">请点击按钮播放</span><span style="color: black;"> </span>',
          ""
        );
        const audioStr = match[0];
        const srcList: any = srcExp.exec(audioStr);
        const src = srcList?.length > 0 ? srcList[0] : "";
        const srcNum = src.replace(`src="`, "");
        const newStr = `<div class="dv-audio"><custom-audio musicUrl="${srcNum}"/></div>`;
        contentHtml = contentHtml.replace(audioStr, newStr);
      }

      const comp = defineComponent({
        template: `${contentHtml}`,
      });
      const app = createApp(comp);
      app.component("custom-audio", CustomAudio);
      nextTick(() => {
        app.mount("#dvCompile");
      });
    };

    // 保存选项值
    const handleAnswer = (optionId: any) => {
      if (!props.disabled) {
        if (currentAnswer.value === optionId) {
          currentAnswer.value = undefined;
        } else {
          currentAnswer.value = optionId;
        }
      }
    };

    // 父组件获取答案等参数
    const getAnswer = () => {
      // console.log("我是子组件11111", questionData.value.answer_params);
      // console.log("currentAnswer.value", currentAnswer.value);
      // type:0|不保存答案 1｜保存答案
      if (currentAnswer.value === undefined) {
        if (questionData.value.answer_params === undefined) {
          return { type: 0 };
        } else {
          return {
            answer_params: undefined,
            type: 1,
          };
        }
      } else {
        if (questionData.value.answer_params === undefined) {
          return {
            answer_params: { is_correct: currentAnswer.value },
            type: 1,
          };
        } else {
          if (
            questionData.value.answer_params.is_correct === currentAnswer.value
          ) {
            return { type: 0 };
          } else {
            return {
              answer_params: { is_correct: currentAnswer.value },
              type: 1,
            };
          }
        }
      }
    };

    // 修改选中选项
    const handleAnswer1 = (optionId: number) => {
      if (currentAnswer.value === optionId) {
        currentAnswer.value = undefined;
        ctx.emit("changePartsAnswer", {
          answer_params: undefined,
        });
      } else {
        currentAnswer.value = optionId;
        ctx.emit("changePartsAnswer", {
          answer_params: { is_correct: optionId },
        });
      }
    };
    const checkIsCorrect = () => {
      let isCorrect = false;
      if (questionData.value.answer_params) {
        isCorrect =
          questionData.value.answer_params.is_correct ===
          questionData.value.correct_option.is_correct;
      }

      return isCorrect;
    };

    onBeforeMount(() => {
      handleTitleHtml();
    });
    onMounted(() => {
      // console.dir(dvRef.value);
      unLock();
    });
    return {
      questionData,
      currentAnswer,
      correctOption,
      disabledAnswer,
      props,
      handleAnswer,
      getAnswer,
      checkIsCorrect,
    };
  },
});
